import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

import PurchaseOrderReportFilterContainer from '@/Modules/ReportsModule/PurchaseOrdersReport/containers/purchase-orders-report-filter/purchase-orders-report-filter.container';
import { APP_ROUTES } from '@/shared/config/routes-config';
import { UserRole } from '@/shared/enums/user-role.enum';
import { RouteConfig } from '@/shared/interfaces/routes-config.interface';
import DefaultLayout from '@/shared/layouts/default/default.layout';

const PurchaseOrderReportContainer = React.lazy(
  () => import('../../containers/purchase-orders-report-list/purchase-orders-report.container')
);

const { FILTER, LIST } = APP_ROUTES.PURCHASE_ORDERS_REPORT_MODULE.CHILDREN as RouteConfig;

const purchaseOrdersReportFilterPath = FILTER.FULL_PATH;
const purchaseOrdersReportPath = LIST.FULL_PATH;

export const PurchaseOrdersReportsRoutesConfig: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={purchaseOrdersReportFilterPath} />
  },
  {
    path: purchaseOrdersReportFilterPath,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[UserRole.ADMIN, UserRole.SALES_MANAGER, UserRole.FINANCE_OFFICER]}
          component={PurchaseOrderReportFilterContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: purchaseOrdersReportPath,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[UserRole.ADMIN, UserRole.SALES_MANAGER, UserRole.FINANCE_OFFICER]}
          component={PurchaseOrderReportContainer}
        />
      </React.Suspense>
    )
  }
];
